export const bookingTabs = {
    ACTIVE_BOOKINGS: 'activeBookings',
    OLD_BOOKINGS: 'oldBookings'
}